export type SimulatorAppCategory = "desktop" | "admin" | "server" | "network" | "security" | "productivity";
export type SimulatorChangeType = "visual" | "interaction" | "functional" | "state_data";

export interface SimulatorCommandSchema {
  commandType: string;
  capability: string;
  payloadSchemaKey: string;
}

export interface SimulatorAppManifest {
  appId: string;
  name: string;
  category: SimulatorAppCategory;
  capabilities: string[];
  stateReads: string[];
  stateWrites: string[];
  commands: SimulatorCommandSchema[];
  eventsEmitted: string[];
  targetBindings: string[];
  dependencies: string[];
}

export interface SimulatorImpactReport {
  appId: string;
  changeType: SimulatorChangeType;
  affectedCapabilities: string[];
  affectedTargets: string[];
  requiresEvaluatorReview: boolean;
}

export function buildImpactReport(
  manifest: SimulatorAppManifest,
  changeType: SimulatorChangeType
): SimulatorImpactReport {
  const requiresEvaluatorReview = changeType === "functional" || changeType === "state_data";

  return {
    appId: manifest.appId,
    changeType,
    affectedCapabilities: [...manifest.capabilities],
    affectedTargets: [...manifest.targetBindings],
    requiresEvaluatorReview
  };
}
